import React from "react";
import Select from "src/components/Inputs/Select";
import BaseFormInput from "src/components/Inputs/Formik/BaseFormInput";

const FormSelect = ({ ...props }) => (
  <BaseFormInput component={Select} {...props} />
);

export default FormSelect;
